<template>
  <rest-form
    :save-endpoint="{}"
    :after-save="null"
    :model="model"
    :disabled="true"
  >
    <form-section>
      <el-row>
        <el-col :span="12">
          <rest-form-item :label="$t('NotificationLog_Campaign')" prop="title">
            <el-input :value="campaignTitle" />
          </rest-form-item>

          <rest-form-item :label="$t('NotificationLog_Channel')" prop="channel">
            <el-input :value="channel" />
          </rest-form-item>

          <rest-form-item
            :label="$t('NotificationLog_SendDate')"
            prop="send_date"
          >
            <el-input :value="sendDate" />
          </rest-form-item>

          <rest-form-item
            :label="$t('NotificationLog_ExpirationDate')"
            prop="expiration_date"
          >
            <el-input :value="expirationDate" />
          </rest-form-item>
        </el-col>

        <el-col :span="12">
          <rest-form-item :label="$t('NotificationLog_Message')" prop="message">
            <el-input type="textarea" v-model="model.message" class="message" />
          </rest-form-item>
        </el-col>
      </el-row>
    </form-section>
  </rest-form>
</template>

<script>
import RestForm from '@/common/components/rest/RestForm'
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import { MessageTypeLabel } from '@/common/enum/MessageTypeEnum'
import { PushEnvironmentLabel } from '@/common/enum/PushEnvironmentEnum'
import { projectTimezoneDate } from '@/core/helpers'
import { DeviceTypeLabel } from '../../devices/enum/DeviceTypeEnum'

export default {
  name: 'NotificationDetails',

  components: {
    RestForm,
    FormSection,
    RestFormItem
  },

  props: {
    model: {
      required: true
    }
  },

  computed: {
    campaignTitle() {
      return this.model.campaign ? this.model.campaign.title : null
    },

    channel() {
      let channel = this.$t(MessageTypeLabel[this.model.message_type])

      if (this.model.application_id) {
        channel += ' / ' + this.model.application_name
      }

      if (this.model.environment) {
        channel += ' / ' + this.$t(PushEnvironmentLabel[this.model.environment])
      }

      if (this.model.send_mode === 10) {
        channel += ' / ' + this.$t('NotificationLog_Queued')

        if (
          this.model.display_platform_types &&
          this.model.message_type === 4
        ) {
          channel +=
            ' / ' +
            this.model.display_platform_types
              .map(type => {
                return this.$t(DeviceTypeLabel[type])
              })
              .join(' & ')
        }
      }

      return channel
    },

    sendDate() {
      if (this.model.create_time) {
        return projectTimezoneDate(this.model.create_time).format(
          'ddd, DD MMM YYYY HH:mm:ss'
        )
      } else {
        return this.$t('NotificationLog_NotSet')
      }
    },

    project() {
      return this.$store.state.app.project
    },

    expirationDate() {
      if (this.model.expiration_time) {
        return projectTimezoneDate(this.model.expiration_time).format(
          'ddd, DD MMM YYYY HH:mm:ss'
        )
      } else {
        return this.$t('NotificationLog_NotSet')
      }
    }
  }
}
</script>

<style scoped>
.message >>> .el-textarea__inner {
  height: 316px;
}
</style>



// WEBPACK FOOTER //
// src/modules/notifications-log/components/NotificationDetails.vue